import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead() {
  return (<thead>
      <tr>
        <th scope="col" className="col-2">
          <FormattedMessage id="fields.campaignManagement.productList.name" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="fields.campaignManagement.productList.package_name" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="fields.campaignManagement.productList.price" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="fields.campaignManagement.productList.discount_type" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="fields.campaignManagement.productList.discount_value" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="fields.campaignManagement.productList.final_price" />
        </th>
        <th scope="col" className="col-1">
          <FormattedMessage id="components.pages.clients.clientsTable.table.actions" />
        </th>
      </tr>
    </thead>)
}

export { TableHead }
